export default __webpack_public_path__ + "static/media/fromTheFrugalToTheOrnateMobiBanner.fe565095.png";